// AUTO-GENERATED — do not edit by hand.
// Source: smirks_toolkit/data/named_reactions_SMIRKS_master_2col.csv
// Regenerate (from smirks-toolkit repo root):
//   python smirks_toolkit/scripts/gen_reactions_js.py \
//     smirks_toolkit/data/named_reactions_SMIRKS_master_2col.csv \
//     bmaps_integration/frontend/rxnEnumReactions.js
// 245 reactions.

export const RXN_ENUM_REACTIONS = [
    '1,3-Dipolar Cycloaddition',
    'Acetoacetic Ester Condensation',
    'Acetoacetic Ester Synthesis',
    'Acyloin Condensation',
    'Alder-Ene Reaction',
    'Aldol Addition',
    'Aldol Condensation',
    'Appel Reaction',
    'Arbuzov Reaction',
    'Arndt-Eistert Synthesis',
    'Azide-Alkyne 1,3-Dipolar Cycloaddition',
    'Azo Coupling',
    'Baeyer-Villiger Oxidation',
    'Baker-Venkataraman Rearrangement',
    'Balz-Schiemann Reaction',
    'Bamford-Stevens Reaction',
    'Barton Decarboxylation',
    'Barton-McCombie Reaction (Barton Desoxygenation)',
    'Baylis-Hillman Reaction',
    'Beckmann Rearrangement',
    'Benzilic Acid Rearrangement',
    'Benzoin Condensation',
    'Bergman Cyclization',
    'Bestmann-Ohira Reagent',
    'Biginelli Reaction',
    'Birch Reduction',
    'Bischler-Napieralski Reaction',
    'Blaise Reaction',
    'Blanc Reaction',
    'Bohlmann-Rahtz Pyridine Synthesis',
    'Boronic Acid Mannich Reaction',
    'Bouveault-Blanc Reduction',
    'Brook Rearrangement',
    'Brown Hydroboration',
    'Bucherer-Bergs Reaction',
    'Buchwald-Hartwig Cross Coupling Reaction',
    'CBS Reduction',
    'Cadiot-Chodkiewicz Coupling',
    'Cannizzaro Oxidation Reduction',
    'Chan-Lam Coupling',
    'Claisen Condensation',
    'Claisen Rearrangement',
    'Clemmensen Reduction',
    'Click Chemistry',
    'Collins Reagent',
    'Conia-Ene Reaction',
    'Cope Elimination',
    'Cope Rearrangement',
    'Corey-Bakshi-Shibata Reduction',
    'Corey-Chaykovsky Reaction',
    'Corey-Fuchs Reaction',
    'Corey-Kim Oxidation',
    'Corey-Seebach Reaction',
    'Corey-Suggs Reagent',
    'Corey-Winter Olefin Synthesis',
    'Coumarin Synthesis',
    'Criegee Mechanism for Ozonolysis',
    'Cross Metathesis',
    'Curtius Rearrangement (Reaction)',
    'Dakin Reaction',
    'Darzens Condensation',
    'Darzens Reaction',
    'Davis Oxidation',
    'De Kimpe Aziridine Synthesis',
    'Del\u00e9pine Reaction',
    'Dess-Martin Oxidation',
    'Diazotisation',
    'Dieckmann Condensation',
    'Diels-Alder Reaction',
    'Directed ortho Metalation',
    'Doebner Modification',
    'Eglinton Reaction',
    'Ene Reaction',
    'Enyne Metathesis',
    'Epoxidation',
    'Eschweiler-Clarke Reaction',
    'Ester Pyrolysis',
    'Esterification',
    'Favorskii Reaction',
    'Finkelstein Reaction',
    'Fischer Esterification',
    'Fischer Indole Synthesis',
    'Fleming-Tamao Oxidation',
    'Friedel-Crafts Acylation',
    'Friedel-Crafts Alkylation',
    'Friedlaender Synthesis',
    'Fries Rearrangement',
    'Fukuyama Coupling',
    'Fukuyama Reduction',
    'Gabriel Synthesis',
    'Gewald Reaction',
    'Glaser Coupling',
    'Griesbaum Coozonolysis',
    'Grignard Reaction',
    'Grubbs Reaction',
    'Haloform Reaction',
    'Hantzsch Dihydropyridine Synthesis (Pyridine Synthesis)',
    'Hay Coupling',
    'Heck Reaction',
    'Hell-Volhard-Zelinsky Reaction',
    'Henry Reaction',
    'Hiyama Coupling',
    'Hiyama-Denmark Coupling',
    'Hofmann Elimination',
    "Hofmann's Rule",
    'Horner-Wadsworth-Emmons Reaction',
    'Hosomi-Sakurai Reaction',
    'Huisgen Cycloaddition',
    'Hunsdiecker Reaction',
    'Hydroboration',
    'Ireland-Claisen Rearrangement',
    'Itsuno-Corey Reduction',
    'Iwanow Reaction (Reagent)',
    'Jacobsen Epoxidation',
    'Jacobsen-Katsuki Epoxidation',
    'Jocic Reaction',
    'Johnson-Corey-Chaykovsky Reaction',
    'Jones Oxidation',
    'Julia-Kocienski Olefination',
    'Julia-Lythgoe Olefination',
    'Kabachnik-Fields Reaction',
    'Kindler Reaction',
    'Knoevenagel Condensation',
    'Kochi Reaction',
    'Kolbe Electrolysis',
    'Kolbe Nitrile Synthesis',
    'Kolbe-Schmitt Reaction',
    "Koser's Reagent",
    'Kowalski Ester Homologation',
    'Kulinkovich Reaction',
    'Kulinkovich-Szymoniak Reaction',
    'Kulinkovich-de Meijere Reaction',
    'Kumada Coupling',
    "Lawesson's Reagent",
    'Leuckart Thiophenol Reaction',
    'Luche Reduction',
    'Malonic Ester Synthesis',
    'Mannich Reaction',
    "Markovnikov's Rule",
    'McMurry Reaction',
    'Meerwein-Ponndorf-Verley Reduction',
    'Michael Addition',
    'Michaelis-Arbuzov Reaction',
    'Mitsunobu Reaction',
    'Miyaura Borylation Reaction',
    'Modified Julia Olefination',
    'Mukaiyama Aldol Addition',
    "Myers' Modification of the Ramberg-B\u00e4cklund Reaction",
    'Myers-Saito Cyclization',
    'Nazarov Cyclization',
    'Nef Reaction',
    'Negishi Coupling',
    'Newman-Kwart Rearrangement',
    'Nitroaldol Reaction',
    'Nozaki-Hiyama Coupling',
    'Nucleophilic Substitution (SN1 / SN2)',
    "O'Donnell Amino Acid Synthesis",
    'Ohira-Bestmann Reagent',
    'Olefin Metathesis',
    'Oppenauer Oxidation',
    'Overman Rearrangement',
    'Oxy-Cope Rearrangement',
    'Ozonolysis',
    'Paal-Knorr Furan Synthesis',
    'Paal-Knorr Pyrrole Synthesis',
    'Paal-Knorr Thiophene Synthesis',
    'Passerini Reaction',
    'Paterno-B\u00fcchi Reaction',
    'Pauson-Khand Reaction',
    'Pechmann Condensation',
    'Petasis Reaction',
    'Peterson Olefination',
    'Pinacol Coupling Reaction',
    'Pinacol Rearrangement',
    'Pinner Reaction',
    'Prilezhaev Reaction',
    'Prins Reaction',
    'Pr\u00e9vost Reaction',
    'Pschorr Reaction',
    'Ramberg-B\u00e4cklund Reaction',
    'Reformatsky Reaction',
    'Ring Closing Metathesis',
    'Ring Opening Metathesis (Polymerization)',
    'Ritter Reaction',
    'Robinson Annulation',
    'Rosenmund Reduction',
    'Rosenmund-von Braun Reaction',
    'Rubottom Oxidation',
    'Sakurai Reaction',
    'Sandmeyer Reaction',
    'Sarett Reagent',
    "Saytzeff's Rule",
    'Schiemann Reaction',
    'Schlosser Modification',
    'Schmidt Reaction',
    'Schotten-Baumann Reaction',
    'Seebach Umpolung',
    'Seyferth-Gilbert Homologation',
    'Shapiro Reaction',
    'Sharpless Aminohydroxylation',
    'Sharpless Dihydroxylation',
    'Sharpless Epoxidation',
    'Shi Epoxidation',
    'Simmons-Smith Reaction',
    'Sonogashira Coupling',
    'Staudinger Cycloaddition',
    'Staudinger Reaction',
    'Staudinger Reduction',
    'Staudinger Synthesis',
    'Steglich Esterification',
    'Stetter Reaction',
    'Stille Coupling',
    'Strecker Synthesis',
    'Suzuki Coupling',
    'Swern Oxidation',
    'Tamao-Kumada Oxidation',
    'Tebbe Olefination',
    'Tishchenko Reaction',
    'Trost Allylation',
    'Tsuji-Trost Reaction',
    'Ugi Reaction',
    'Ullmann Reaction',
    'Upjohn Dihydroxylation',
    'Van Leusen Imidazole Synthesis',
    'Van Leusen Oxazole Synthesis',
    'Van Leusen Reaction',
    'Vicarious Nucleophilic Substitution',
    'Vilsmeier Reaction',
    'Wacker-Tsuji Oxidation',
    'Weinreb Ketone Synthesis',
    'Wenker Synthesis',
    'Willgerodt-Kindler Reaction',
    'Williamson Synthesis',
    'Wittig Reaction',
    'Wittig-Horner Reaction',
    'Wohl-Ziegler Reaction',
    'Wolff Rearrangement',
    'Wolff-Kishner Reduction',
    'Woodward Reaction',
    'Woodward cis-Hydroxylation',
    'Wurtz Reaction',
    'Wurtz-Fittig Reaction',
    'Yamaguchi Esterification',
    '[1,2]-Wittig Rearrangement',
    '[2,3]-Wittig Rearrangement',
];
